/* eslint-disable import/no-cycle */

import { http, httpStockManager } from './config';

export const stats = {
  getShippedQuantities: params =>
    http.get('/commands/shipped-quantities', { params }),
  getAverageDeliveryDays: params =>
    http.get('/commands/average-delivery-days', { params }),
  getQuantitiesByStates: params =>
    http.get('/commands/quantities-by-states', { params }),
  getShippedQuantitiesByCarrier: params =>
    http.get('/commands/shipped-quantities-by-carrier', { params }),
  getShippedItemsQuantities: params =>
    http.get('/commands/shipped-items-quantities', { params }),
  getProcessedShipmentsNaturesQuantities: params =>
    http.get('/return-vouchers/processed-shipments-natures-quantities', {
      params
    }),
  getProcessedItemsNaturesQuantities: params =>
    http.get('/return-vouchers/processed-items-natures-quantities', {
      params
    }),
  getReasonsQuantities: params =>
    http.get('/return-vouchers/reasons-quantities', {
      params
    }),
  getReceptionsQuantities: params =>
    httpStockManager.get('/receptions/quantities', {
      params
    }),
  getExpectedProductsQuantities: params =>
    httpStockManager.get('/receptions/expected-products-quantities', {
      params
    }),
  getActualProductsQuantities: params =>
    httpStockManager.get('/receptions/actual-products-quantities', {
      params
    }),
  getProcessedQuantities: params =>
    http.get('/return-vouchers/processed-quantities', {
      params
    }),
  getMultipleExchangesQuantity: params =>
    http.get('/return-vouchers/multiple-exchanges-quantity', {
      params
    }),
  getExchangesFollowedByRefundsQuantity: params =>
    http.get('/return-vouchers/exchanges-followed-by-refunds-quantity', {
      params
    })
};

export const operations = {
  getOperations: params => http.get('/customer-operations', { params }),
  getOperation: commandId => http.get(`/customer-operations/${commandId}`)
};

export const receptions = {
  getReceptions: params => httpStockManager.get('/receptions', { params }),
  getReception: commandId => httpStockManager.get(`/receptions/${commandId}`),
  exportReceptionComparative: receptionId =>
    httpStockManager.get(`/receptions/${receptionId}/comparative`),
  exportReceptionsComparative: params =>
    httpStockManager.get('/receptions/comparative', { params })
};

export const magicLink = {
  refreshToken: data => http.post('/api-tokens/refresh', data)
};

export const stock = {
  getStock: companyId =>
    httpStockManager.get('/products/get-from-company-with-forecast', {
      params: { companyId }
    }),
  getProducts: data => httpStockManager.post('/products', data),
  getProduct: id => httpStockManager.get('/product', { params: { id } }),
  getIsStockHandled: params =>
    httpStockManager.get('/company/is-stock-handled', { params }),
  getProductBarcode: () => httpStockManager.get('/product-barcode-values/mine'),
  updateItem: data => httpStockManager.post(`/product/update`, data),
  getRequiredAttributes: () => httpStockManager.get(`/required-attributes`),
  createProductBatch: data =>
    httpStockManager.post('/create-product-batch', data),
  replaceBufferQuantity: data =>
    httpStockManager.post(`/products/${data.id}/replace-buffer-quantity`, data)
};

export const user = {
  getUsedCarriers: () => http.get('/customer-companies/mine/used-carriers'),
  getCurrentUserInformations: () => http.get('/users/me'),
  addCollaborator: data => http.post('/coworker-invitations/create', data),
  update: userInformations =>
    http.post('/customers/me/update', userInformations)
};

export const phone = {
  createPhoneCode: data => http.post('/phone-codes/create', data)
};

export const signin = {
  createToken: data => http.post('api-tokens/create', data)
};

export const signup = {
  createCustomer: data => http.post('/customers/create', data),
  acceptCoworkerInvitation: data =>
    http.post('/coworker-invitations/accept', data)
};

export const commands = {
  getCommand: commandId => http.get(`/commands/${commandId}`),
  updateOffer: data =>
    http.post(`/commands/${data.commandId}/update-offer`, data),
  updateCommand: data => http.post(`/commands/${data.id}/update`, data),
  updateAddress: data => http.post(`/commands/${data.id}/change-address`, data),
  commandsReport: data => http.post(`/commands/report`, data),
  createBatch: data => http.post('/commands/create-batch', data),
  checkIfReferenceAlreadyExist: data =>
    http.post('/commands/external-references', data),
  cancel: commandId => http.post(`/commands/${commandId}/cancel`),
  merge: data => http.post('/commands/merge', data),
  generateReturnLabel: commandId =>
    http.post(`/commands/${commandId}/generate-return-label`),
  updateItems: data => http.post(`/commands/${data.id}/update-items`, data),
  addCommand: data => http.post(`/commands/create`, data),
  duplicateCommand: commandId => http.post(`/commands/${commandId}/duplicate`),
  search: data => http.post('commands/search', data)
};

export const symplOffers = {
  getPrices: params => http.get('/sympl-offers/prices', { params })
};

export const pickupPoints = {
  getPickupPoints: params => http.get('/pickup-points/available', { params })
};

export const course = {
  getCurrentCourse: () => http.get('/courses/in-progress'),
  create: data => http.post('/courses/create', data),
  addCommands: data => http.post(`/courses/${data.id}/add-commands`, data),
  cancel: courseId => http.post(`/courses/${courseId}/cancel`)
};

export const returnVouchers = {
  getReturnVouchers: params =>
    http.get('return-vouchers/as-sender', { params }),
  getReturnVoucher: returnVoucherId =>
    http.get(`/return-vouchers/${returnVoucherId}`),
  report: data => http.post('/return-vouchers/report', data),
  cancel: returnVoucherId =>
    http.post(`/return-vouchers/${returnVoucherId}/cancel`),
  update: data =>
    http.post(`/return-vouchers/${data.returnVoucherId}/set-items`, data)
};

export const address = {
  getAddress: () => http.get('/address-book-entries'),
  create: data => http.post('/address-book-entries/create', data),
  delete: data => http.post('/address-book-entries/delete', data)
};
